/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Therapist of a patient derived from their most recent appointment.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientTherapist { 
    readonly id: number;
    name: string;
    email: string;
}
export const PatientTherapist_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientTherapist_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];

export const PatientTherapist_email_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(254), Validators.email,];


